import { render, staticRenderFns } from "./GeneralAudit.vue?vue&type=template&id=87b62e5c"
import script from "./GeneralAudit.vue?vue&type=script&lang=js"
export * from "./GeneralAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports